/* Tysk katalog for locale-transaction-detail-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'transaction.annulBy': 'Storniert von',
  "transaction.annulAudit": "Stornierungshistorie",
  "transaction.annulledAt": "Storniert am",
  "transaction.annulReason": "Begründung",
  "transaction.annulActor": "Benutzer-ID",
  "transaction.reversalDate": "Buchungsdatum der Gegenbuchung",
  "transaction.openOriginal": "Originalbuchung öffnen",
  "transaction.openReversal": "Gegenbuchung öffnen",
  "transaction.auditMissing": "Nicht erfasst",
  "transaction.reversalMissing": "Die Gegenbuchung ist im geladenen Journal nicht verfügbar.",
  "transaction.auditDebit": "Soll",
  "transaction.auditCredit": "Haben",

  'transaction.incompleteBasis': 'Die Journalabdeckung ist unvollständig. Dieser Beleg wird zur Dokumentation und Diagnose angezeigt; die Summen dürfen nicht als vollständig verstanden werden.',
  'route.transaction': 'Transaktion',
  'transaction.back': 'Zurück zu allen Transaktionen',
  'transaction.title': 'Transaktion',
  'transaction.posting': 'Buchung',
  'transaction.summary': 'Zusammenfassung – Beträge auf und von Konten',
  'transaction.account': 'Konto',
  'transaction.incoming': 'Auf Konto',
  'transaction.outgoing': 'Von Konto',
  'transaction.total': 'Summe',
  'transaction.description': 'Beschreibung',
  'transaction.links': 'Verknüpfte Datensätze',
  'transaction.sourceLead': 'Dies ist die Buchung von',
  'transaction.sourceHelp': 'Öffne die Quelle, wenn du die Transaktion oder eine verknüpfte Zahlung ändern möchtest.',
  'transaction.relatedPayments': 'Zugehörige Zahlungen',
  'transaction.correctionReplacement': 'Ersatzbeleg',
  'transaction.correctionOriginal': 'Ursprünglicher Beleg',
  'transaction.correctionReason': 'Grund der Korrektur',
  'transaction.created': 'Erstellt',
  'transaction.by': 'von',
  'transaction.vatCodes': 'MwSt.-Codes',
  'transaction.accountNumber': 'Kontonr.',
  'transaction.name': 'Name',
  'transaction.amount': 'Betrag',
  'transaction.documentation': 'Dokumentation',
  'transaction.generatedDocument': 'Das Rechnungsdokument wird erzeugt, wenn du es öffnest oder herunterlädst.',
  'transaction.noDocumentation': 'Dieser Transaktion ist keine Dokumentation beigefügt.',
  'transaction.open': 'Offene Buchung',
  'transaction.locked': 'Gesperrte Buchung',
  'transaction.annulled': 'Storniert',
  'transaction.fallbackType': 'Buchung',
  'transaction.notFound': 'Transaktion nicht gefunden',
  'transaction.notFoundHelp': 'Die Transaktion wurde möglicherweise storniert, gehört zu einem anderen Geschäftsjahr oder ist nicht mehr verfügbar.',
  'transaction.invoice': 'Rechnung',
  'transaction.purchase': 'Einkauf',
  'transaction.otherSale': 'Sonstiger Verkauf',
  'transaction.customs': 'Zollanmeldung',
  'transaction.openDocument': 'Beleg ansehen',
  'transaction.download': 'Herunterladen',
  'transaction.upload': 'Anhang hochladen',
  'transaction.uploaded': 'Anhang hochgeladen.',
  'transaction.uploadFailed': 'Der Anhang konnte nicht hochgeladen werden.',
  'transaction.documentFailed': 'Der Beleg konnte nicht vom Backend abgerufen werden.',
  'transaction.previewFailed': 'Der Beleg konnte nicht angezeigt werden.',
  'transaction.lost': 'Beleg fehlt',
  'transaction.lostPrompt': 'Erläuterung für das Protokoll (optional):',
  'transaction.lostSaved': 'Der Beleg wurde als fehlend markiert.',
  'transaction.lostFailed': 'Der Beleg konnte nicht als fehlend markiert werden.',
  'transaction.annul': 'Transaktion stornieren',
  'transaction.annulQuestion': 'Transaktion stornieren?',
  'transaction.creditQuestion': 'Rechnung gutschreiben?',
  'transaction.credit': 'Gutschreiben',
  'transaction.annulling': 'Wird storniert...',
  'transaction.annulHelp': 'Die Transaktion wird storniert und als Historie aufbewahrt, aber nicht in die Berichtsgrundlage einbezogen.',
  'transaction.creditHelp': 'Die Rechnung wird mit einer Gutschrift ausgeglichen, die als Entwurf zur Prüfung vor dem Senden erstellt wird.',
  'transaction.creditDraft': 'Die Gutschrift wurde als Entwurf erstellt. Prüfe und sende sie aus der Rechnungsliste.',
  'transaction.annulledSaved': 'Die Transaktion wurde storniert.',
  'transaction.annulFailed': 'Die Transaktion konnte nicht storniert werden.',
  'transaction.privateReimbursed': 'Die private Auslage wurde erstattet.',
  'transaction.privateReimburseFailed': 'Die private Auslage konnte nicht erstattet werden.',
  'transaction.reimbursePrivate': 'Private Auslage erstatten',
  'transaction.reimbursePrivateHelp': 'Bucht die Erstattung vom gewählten Firmenbankkonto gegen Konto 2060, ohne Aufwand oder MwSt. erneut zu buchen.',
  'transaction.paymentDate': 'Zahlungsdatum',
  'transaction.bankAccount': 'Bankkonto',
  'transaction.goTo': 'Gehe zu',
  'transaction.bank': 'Bank',
  'transaction.vat': 'MwSt.',
  'transaction.yearEnd': 'Jahresabschluss',
});
